var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plat-bar"},[_c('div',{staticClass:"plat-bar-icon icon-platform"}),_vm._l((_vm.platForms),function(plat){return _c('div',{key:plat.name,class:[
      'plat-bar-item',
      plat.icon,
      { active: _vm.currentPlatId === plat.id }
    ],on:{"click":function($event){return _vm.onPlatClick(plat.id)}}},[(!plat.icon)?_c('span',[_vm._v(_vm._s(plat.name))]):_vm._e()])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }